import { cursorPaginationFieldPolicy } from '../../../utils/policies/cursorPaginationFieldPolicy';
import type { TypePolicies } from '../../../utils/types/TypePolicies';
import { imageMerge } from '../utils/imageMerge';

export const typePolicies: TypePolicies = {
  Project: {
    fields: {
      appliedResourceControlPolicies: {
        /**
         * The `ResourceControlPolicy` type is non-normalized, for now. This makes
         * sense because There Can Be Only One (policy per project).
         */
        merge: true,
      },
      assets: cursorPaginationFieldPolicy(),
      collections: cursorPaginationFieldPolicy(['projectId', 'order']),
      /**
       * @note Ensure that the results for field definitions that exclude
       * system fields are cached separately.
       */
      fieldDefinitions: {
        keyArgs: ['filters', ['excludeSystemFields']],
        merge: true,
      },
      fieldGroups: cursorPaginationFieldPolicy(),
      fieldValues: cursorPaginationFieldPolicy(),
      images: {
        merge: (existing, incoming) => imageMerge(existing, incoming),
      },
      legacyShares: cursorPaginationFieldPolicy(['orderBy', 'type']),
      shares: cursorPaginationFieldPolicy(['orderBy', 'filters']),
      uploadLinks: cursorPaginationFieldPolicy(['orderBy', 'filter']),
      // @todo (GROW-3402): remove once new field is added to BE schema, at
      // which point we can update the cache with full Project returned by
      // the `PROJECT_CREATED` subscription message, rather than relying on
      // local @client schema and typePolicy.
      isLoading: (existing) => {
        return !!existing;
      },
    },
  },
};
